/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Model_Token_TitleInputs */



/**
* | output |
* | --- |
* | "Token Usage by Model" |
*
* @param {Dashboard_Model_Token_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_model_token_title = /** @type {((inputs?: Dashboard_Model_Token_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Model_Token_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Token-Verbrauch nach Modell")
	return /** @type {LocalizedString} */ ("Token Usage by Model")
});